module.exports = __webpack_public_path__ + "img/34.a2474230.jpg";